import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { IconProps } from '@material-ui/core/Icon';
import Tooltip from '@material-ui/core/Tooltip';
import ErrorIcon from '@material-ui/icons/Cancel';
import WarningIcon from '@material-ui/icons/Warning';
import SuccessIcon from '@material-ui/icons/CheckCircle';

/**
 * This molecule presents an icon to indicate validation status,
 * and a description when hover over the icon
 */

interface Props extends IconProps {
  status: 'error' | 'warning' | 'success';
  description?: string;
}

function ValidationStatusIndicator({ status = 'success', description }: Props) {
  const classes = useStyles();

  const iconLookup = {
    error: <ErrorIcon color="error" />,
    warning: <WarningIcon className={classes.warning} />,
  };

  if (status === 'success') {
    return (
      <div className={classes.root}>
        <SuccessIcon className={classes.success} />
      </div>
    );
  }

  if (!description) {
    return <div className={classes.root}>{iconLookup[status]}</div>;
  }

  return (
    <div className={classes.root}>
      <Tooltip arrow title={<div dangerouslySetInnerHTML={{ __html: description }} />}>
        {iconLookup[status]}
      </Tooltip>
    </div>
  );
}

const useStyles = makeStyles(theme => ({
  root: {
    float: 'right',
    maxHeight: 24,
  },
  warning: {
    color: theme.palette.warning.main,
  },
  success: {
    color: theme.palette.success.main,
  },
}));

export default ValidationStatusIndicator;
